import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "../../API/apiServices";
import credential from "../../API/Credentials.json";
const apiMethod = credential?.request?.post;

export const loginUser = createAsyncThunk(
  "login/loginUser",
  async (apidata, { rejectWithValue }) => {
    try {
      const endpoint = credential?.Login_API?.end_point;
      const response = await apiRequest(apiMethod, endpoint, apidata);
      if (response && response.success) {
        return response;
      }
      return rejectWithValue(response.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const forgotPassUser = createAsyncThunk(
  "forgotPassword/forgotPassUser",
  async (apiData, { rejectWithValue }) => {
    try {
      const endpoint = credential?.ForgotPass_API?.end_point;
      const response = await apiRequest(apiMethod, endpoint, apiData);
      if (response && response.success) {
        return response;
      }
      return rejectWithValue(response.message); 
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const resetPassUser = createAsyncThunk(
  "resetPassword/resetPassUser",
  async (apiData, { rejectWithValue }) => {
    try {
      const endpoint = credential?.ResetPass_API?.end_point;
      const response = await apiRequest(apiMethod, endpoint, apiData);
      if (response && response.success) {
        return response;
      }
      return rejectWithValue(response.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const LoginSlice = createSlice({
  name: "login",
  initialState: {
    userLoginData: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    setUserLoginData: (state, action) => {
      state.userLoginData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(loginUser.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.success = true;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(forgotPassUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(forgotPassUser.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.success = true;
      })
      .addCase(forgotPassUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(resetPassUser.pending, (state) => {
        state.loading = true;
        state.resetError = null;
        state.resetSuccess = false;
      })
      .addCase(resetPassUser.fulfilled, (state) => {
        state.loading = false;
        state.resetError = null;
        state.resetSuccess = true;
      })
      .addCase(resetPassUser.rejected, (state, action) => {
        state.loading = false;
        state.resetError = action.payload;
        state.resetSuccess = false;
      });
  },
});

export const { setUserLoginData } = LoginSlice.actions;
export default LoginSlice.reducer;
